var map = {
	"./amplify-amazon-button_5.entry.js": [
		2528,
		528
	],
	"./amplify-auth-container.entry.js": [
		2832,
		832
	],
	"./amplify-auth-fields_9.entry.js": [
		3414,
		414
	],
	"./amplify-authenticator.entry.js": [
		2929,
		929
	],
	"./amplify-button_3.entry.js": [
		4256,
		256
	],
	"./amplify-chatbot.entry.js": [
		3320,
		320
	],
	"./amplify-checkbox.entry.js": [
		8652,
		652
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		7829,
		829
	],
	"./amplify-container.entry.js": [
		1776,
		776
	],
	"./amplify-federated-buttons_2.entry.js": [
		2545,
		545
	],
	"./amplify-federated-sign-in.entry.js": [
		6213,
		213
	],
	"./amplify-form-field_4.entry.js": [
		5249,
		249
	],
	"./amplify-greetings.entry.js": [
		179,
		6
	],
	"./amplify-icon-button.entry.js": [
		9623,
		623
	],
	"./amplify-icon.entry.js": [
		6315,
		315
	],
	"./amplify-link.entry.js": [
		1732,
		732
	],
	"./amplify-nav_2.entry.js": [
		5167,
		730
	],
	"./amplify-photo-picker.entry.js": [
		5902,
		902
	],
	"./amplify-picker.entry.js": [
		8381,
		381
	],
	"./amplify-radio-button_3.entry.js": [
		5335,
		335
	],
	"./amplify-s3-album.entry.js": [
		2749,
		818,
		749
	],
	"./amplify-s3-image-picker.entry.js": [
		8033,
		818,
		33
	],
	"./amplify-s3-image.entry.js": [
		6111,
		818,
		111
	],
	"./amplify-s3-text-picker.entry.js": [
		7596,
		818,
		555
	],
	"./amplify-s3-text.entry.js": [
		8248,
		818,
		248
	],
	"./amplify-select-mfa-type.entry.js": [
		6549,
		549
	],
	"./amplify-sign-in-button.entry.js": [
		3364,
		364
	],
	"./amplify-tooltip.entry.js": [
		6053,
		53
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1766;
module.exports = webpackAsyncContext;